import React, { useState, useEffect } from "react";
import { WHY } from "../../../../assets";
import { motion, useMotionValue, useTransform } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "./Why.css";

export default function Why() {
  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.1,
  });

  const data = [
    { id: 1, txt1: "FAMILY", txt2: "DENTISTRY", img: WHY.ONE },
    { id: 2, txt1: "PATIENT", txt2: "COMFORT", img: WHY.TWO },
    { id: 3, txt1: "CUTTING-EDGE", txt2: "TREATMENTS", img: WHY.THR },
    { id: 4, txt1: "FUN", txt2: "ENVIRONMENT", img: WHY.FOU },
  ];

  return (
    <div className="bg-white h-full flex justify-center items-center px-5 overflow-x-hidden font-poppins tracking-wider">
      <div className="max-w-screen-2xl w-full h-full">
        <p className="lg:text-[60px] md:text-[50px] text-[40px] font-extralight text-secondary text-start md:text-center lg:text-start">
          Why <span className="font-semibold">us</span>?
        </p>
        <div
          ref={ref}
          className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 py-10 lg:gap-7 md:gap-10 gap-5"
        >
          {data.map((itm, index) => (
            <Card key={itm.id} itm={itm} index={index} inView={inView} />
          ))}
        </div>
      </div>
    </div>
  );
}

const Card = ({ itm, index, inView }) => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const rotateX = useTransform(y, [-100, 100], [30, -30]);
  const rotateY = useTransform(x, [-100, 100], [-30, 30]);

  return (
    <div className="bg-re relative w-full h-full flex perspective-2000">
      <motion.div
        style={{ x, y, rotateX, rotateY }}
        initial={{
          opacity: 0,
          translateX: index % 2 === 0 ? -50 : 150,
          translateY: -150,
        }}
        animate={{
          opacity: inView ? 1 : 0,
          translateX: inView ? 0 : index % 2 === 0 ? -50 : 100,
          translateY: inView ? 0 : -100,
        }}
        transition={{ duration: 1, delay: index * 0.2 }}
        className="w-full h-[120px] md:w-full md:h-full flex relative "
      >
        <motion.div
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 300 }}
          className="block1 w-full h-full bg-blur rounded-[18px] md:rounded-[46px] py-8 px-7 md:p-10 lg:p-8 xl:p-10 2xl:p-10 flex md:flex-col md:justify-between z-9 select-none"
        >
          <motion.img
            src={itm.img}
            alt={itm.txt1}
            className="md:w-[22%] md:h-auto md:mb-4 select-none md:p-0"
          />
          <div className="bg-rd md:mt-[33%] pl-[8%] md:pl-0 flex flex-col items-start justify-center">
            <p className="text-xl md:text-2xl lg:text-xl xl:text-2xl 2xl:text-2xl font-bold text-secondary tracking-wider">
              {itm.txt1}
            </p>
            <p className="text-xl md:text-2xl lg:text-xl xl:text-2xl 2xl:text-2xl font-bold text-secondary tracking-wider">
              {itm.txt2}
            </p>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};
